import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import i18n from 'i18next';
import { useTranslation } from "react-i18next";

import useAuthAdminStore from "../../store/useAuthAdminStore";
import Flex from "../core/Flex";
import FormTitle from "../form/FormTitle";
import FormText from "../form/FormText";
import Space from "../core/Space";
import { basename } from "../../setting";

function HeaderBar({ title, name, role, ...props }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { logout } = useAuthAdminStore();

  return (
    <HeaderBarContainer {...props}>
      <Title>{title}</Title>

      <Flex>
        <FormText style={{ color: "var(--aia-bx-white)" }}>{name}</FormText>
        <FormText style={{ color: "var(--aia-bx-white)" }}>({t(`translation:admin.common.role.${role}` ?? "")})</FormText>
        <Space width={10} />
        <span style={{ color: "var(--aia-bx-white)" }}>|</span>
        <Space width={10} />
        <LogoutBtn onClick={() => {
          logout();
          navigate(`/${basename}/${i18n.language}/admin/signin`);
        }}>{t("translation:admin.signIn.signOut")}</LogoutBtn>
        <Space width={10} />
      </Flex>

      <Corner />
    </HeaderBarContainer>
  );
}

const HeaderBarContainer = styled(Flex)`
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  background-color: #00457a;
  padding: 20px 10px;
  position: relative;
`;

const Title = styled(FormTitle)`
  margin-bottom: 0px;
  color: var(--aia-bx-white);
`;

const Corner = styled.div`
  position: absolute;
  left: 0;
  bottom: -50px;
  width: 50px;
  height: 50px;
  background: radial-gradient(101px at right bottom,transparent 49%,#00457a 50%);
`;

const LogoutBtn = styled.button`
  border: none;
  border-radius: 5px;
  background-color: transparent;
  color: var(--aia-bx-white);
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
  text-decoration: underline;

  &:hover {
    background-color: var(--aia-bx-medium-blue-50);
  }
`;

export default HeaderBar;